import React, { useState } from 'react';
import { Button } from '../../shadComponents/ui/button';

export interface BoothModeState {
    activationId: number;
    testMode: boolean;
    toasterMode: boolean;
    canChangeTestMode: boolean;
    testModeBlockedReason?: string;
}

export default function BoothModes({ modes, disabled, onSet }: {
    modes?: BoothModeState | null;
    disabled: boolean;
    onSet: (command: 'set_test_mode' | 'set_toaster_mode', activationId: number, enabled: boolean) => Promise<boolean>;
}) {
    const [sending, setSending] = useState(false);
    if (modes === undefined) return <p className="text-sm text-muted-foreground">Connect with an updated Clickerbooth app to control booth modes.</p>;
    if (modes === null) return <p className="text-sm text-muted-foreground">Select an activation on this device to control booth modes.</p>;
    const send = async (command: 'set_test_mode' | 'set_toaster_mode', enabled: boolean) => {
        setSending(true);
        try { await onSet(command, modes.activationId, enabled); }
        finally { setSending(false); }
    };
    return <div className="space-y-4">
        <p className="text-xs text-muted-foreground">Status updates when confirmed by the booth. Queued changes appear in Change History.</p>
        <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex-1">
                <div className="text-sm font-medium">Test Mode: {modes.testMode ? 'On' : 'Off'}</div>
                <p className="text-sm text-muted-foreground">Preview paid destinations without payment. Remembered for this activation until disabled.</p>
                {!modes.canChangeTestMode && <p className="text-sm text-muted-foreground">{modes.testModeBlockedReason || 'Test Mode cannot be changed right now.'}</p>}
            </div>
            <Button size="sm" variant="outline" disabled={disabled || sending || !modes.canChangeTestMode}
                onClick={() => send('set_test_mode', !modes.testMode)}>{modes.testMode ? 'Disable' : 'Enable'} Test Mode</Button>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 border-t pt-4">
            <div className="flex-1">
                <div className="text-sm font-medium">Toaster Mode: {modes.toasterMode ? 'On' : 'Off'}</div>
                <p className="text-sm text-muted-foreground">Reopen this activation with its current camera and printer when the booth restarts.</p>
            </div>
            <Button size="sm" variant="outline" disabled={disabled || sending}
                onClick={() => send('set_toaster_mode', !modes.toasterMode)}>{modes.toasterMode ? 'Disable' : 'Enable'} Toaster Mode</Button>
        </div>
    </div>;
}
